import Piwik from "piwik-wrap";
import { getAuthData } from 'authStore';

Piwik.init(process.env.KOOTH_PIWIK_ANALYTICS_SERVER, '1').loadScript();

class Tracker {

    processMembersAppAction(action) {
        if (action.type === "@@router/LOCATION_CHANGE") {
            let fullPath = action.payload.basename+action.payload.pathname+action.payload.search;
            Piwik.p
                .then(() => Piwik.setDocumentTitle(action.payload.pathname))
                .then(() => Piwik.setCustomUrl(fullPath.toString()))
                .then(() => Piwik.trackPageView())
                .then(() => {
                  const auth = getAuthData();
                  if (auth) {
                    const { yob, mob } = auth.user;
                    const dob = yob!='' && mob!='' && mob.length==2 ? yob+'-'+mob : mob!='' && mob.length==1 ? yob+'-0'+mob : yob;
                    Piwik.setUserId(auth.user.userName);
                    Piwik.setCustomVariable(1, 'gender', auth.user.gender, 'visit');
                    Piwik.setCustomVariable(2, 'dob', dob, 'visit');
                    Piwik.setCustomVariable(3, 'LA', auth.user.LA, 'visit');
                    Piwik.setCustomVariable(4, 'subLocation', auth.user.subLocation, 'visit');
                    Piwik.setCustomVariable(5, 'ethnicity', auth.user.ethnicity, 'visit');
                    Piwik.setCustomVariable(6, 'ethnicityCategory', auth.user.ethnicityCategory, 'visit');
                  }
                });
        }
        console.log('Analytics action', action); // eslint-disable-line no-console

    }
}

const tracker = new Tracker();

export default tracker;



/** WEBPACK FOOTER **
 ** ./src/members/state/analytics/analyticsTracker.js
 **/